@let isRegular = size() === 'regular';
@let unavailable = unavailableLabel();
<button
    class="relative flex w-fit max-w-full items-center overflow-hidden text-left after:absolute after:inset-0 after:content-[''] hover:after:bg-hovered-layer active:after:bg-pressed-layer"
    type="button"
    [attr.aria-label]="hasVisualPreview() ? attachment().name : null"
    [matTooltip]="attachment().name"
    [ngClass]="
        hasVisualPreview()
            ? 'min-w-0 rounded-lg'
            : isRegular
              ? 'min-w-252 rounded-l-lg rounded-r-2xl bg-surface-B pr-8'
              : 'min-w-168 rounded-lg bg-surface-B pr-4'
    "
    (click)="attachmentClick.emit()"
>
    <interacta-attachment-preview
        class="shrink-0"
        [attachment]="attachment()"
        [iconSize]="isRegular ? 'large' : 'regular'"
        [size]="isRegular ? 'regular' : 'small'"
    />
    @if (hasVisualPreview()) {
        <interacta-attachment-icon
            class="absolute top-4 left-4"
            [attachment]="attachment()"
        />
    } @else {
        <span
            class="flex min-w-0 grow flex-col justify-center px-8 py-4"
            [ngClass]="isRegular ? 'typo-sm' : 'typo-xs'"
        >
            <span
                class="line-clamp-1 break-all"
                [class.text-text-mid-contrast]="!!unavailable"
                [class.typo-sm-bold]="isRegular"
                [class.typo-xs-bold]="!isRegular"
                >{{ attachment().name }}</span
            >
            @if (!unavailable) {
                @if (attachment().creatorUser?.fullName; as creatorName) {
                    <span class="truncate">{{ creatorName }}</span>
                }
                @if (
                    isRegular && attachment().creationTimestamp;
                    as creationDate
                ) {
                    <interacta-creation-date
                        class="text-text-mid-contrast"
                        [date]="creationDate"
                    />
                }
            } @else {
                <interacta-badge
                    class="mt-4 h-18! self-start px-4! typo-xs-bold text-text-on-status"
                    [bgColor]="'status-J'"
                    [rounded]="'small'"
                >
                    {{ unavailable | translate }}
                </interacta-badge>
            }
        </span>
    }
</button>
